import React, { useState, useEffect } from "react";
import axios from "axios";
import styles from "./DashBoard.module.css";
import CreateProductForm from "../CrearProducto/CrearProducto";
import ProductList from "../ProductList/ProductList";
import CreateSoupKits from "../CreateSoupKits/CreateSoupKits";
import KitList from "../KitList/KitList";
import TraePedidos from "../TraePedidos/TraePedidos";
import DashboardMobile from "./DashboardMobile";

const Dashboard = () => {
  const [shippingData, setShippingData] = useState(null);
  const [showCreateProductForm, setShowCreateProductForm] = useState(false);
  const [showProductList, setShowProductList] = useState(false);
  const [showCreateSoupKits, setShowCreateSoupKits] = useState(false);
  const [showKitList, setShowKitList] = useState(false);
  const [showPedidos, setShowPedidos] = useState(false);
  const [showShippingInfo, setShowShippingInfo] = useState(false);

  // Estado para los campos del formulario de actualización
  const [envio, setEnvio] = useState(false);
  const [precio, setPrecio] = useState(0);
  const [envioGratis, setEnvioGratis] = useState(0);

  // Trae la información de envío al montar
  useEffect(() => {
    const fetchShippingData = async () => {
      try {
        const response = await axios.get(
          "https://rezuma-back.onrender.com/ship/shipping"
        );
        setShippingData(response.data[0]); // Ya que es un array de un solo objeto
        setEnvio(response.data[0].envio);
        setPrecio(response.data[0].precio);
        setEnvioGratis(response.data[0].envioGratis);
        console.log(response.data[0].envio);
      } catch (error) {
        console.error("Error fetching shipping data:", error);
      }
    };
    fetchShippingData();
  }, []);

  // Función para actualizar envío
  const updateShipping = async () => {
    try {
      const response = await axios.put(
        `https://rezuma-back.onrender.com/ship/shipping/${shippingData.id}`,
        {
          envio,
          precio,
          envioGratis,
        }
      );
      setShippingData(response.data); // actualizamos el estado con los datos actualizados
      alert("Datos de envío actualizados correctamente");
    } catch (error) {
      console.error("Error al actualizar el envío:", error);
      alert("Error al actualizar");
    }
  };

  // Funciones para mostrar/ocultar secciones
  const toggleCreateProductForm = () => {
    setShowCreateProductForm(!showCreateProductForm);
    setShowProductList(false);
    setShowCreateSoupKits(false);
    setShowKitList(false);
    setShowPedidos(false);
  };

  const toggleProductList = () => {
    setShowProductList(!showProductList);
    setShowCreateProductForm(false);
    setShowCreateSoupKits(false);
    setShowKitList(false);
    setShowPedidos(false);
  };

  const toggleCreateSoupKits = () => {
    setShowCreateSoupKits(!showCreateSoupKits);
    setShowCreateProductForm(false);
    setShowProductList(false);
    setShowKitList(false);
    setShowPedidos(false);
  };

  const toggleKitList = () => {
    setShowKitList(!showKitList);
    setShowCreateProductForm(false);
    setShowProductList(false);
    setShowCreateSoupKits(false);
    setShowPedidos(false);
  };

  const togglePedidos = () => {
    setShowPedidos(!showPedidos);
    setShowCreateProductForm(false);
    setShowProductList(false);
    setShowCreateSoupKits(false);
    setShowKitList(false);
  };

  const toggleShippingInfo = () => {
    setShowShippingInfo(!showShippingInfo);
    setShowCreateProductForm(false);
    setShowProductList(false);
    setShowCreateSoupKits(false);
    setShowKitList(false);
    setShowPedidos(false);
  };

  return (
    <div className={styles.background}>
      {window.innerWidth <= 1120 || window.innerHeight <= 590 ? (
        <DashboardMobile />
      ) : (
        <div className={styles.dashboard}>
          <h1 className={styles.title}>Dashboard</h1>
          <div className={styles.buttonContainer}>
            <button className={styles.button} onClick={toggleCreateProductForm}>
              Crear Producto
            </button>
            <button className={styles.button} onClick={toggleProductList}>
              {showProductList ? "Ocultar Productos" : "Traer Productos"}
            </button>
            <button className={styles.button} onClick={toggleCreateSoupKits}>
              Crear Kit de Sopas
            </button>
            <button className={styles.button} onClick={toggleKitList}>
              {showKitList ? "Ocultar Kits" : "Mostrar Kits"}
            </button>
            <button className={styles.button} onClick={togglePedidos}>
              {showPedidos ? "Ocultar Pedidos" : "Traer Pedidos"}
            </button>
          </div>

          {/* Información de Envío */}
          {shippingData && showShippingInfo && (
            <div className={styles.shippingInfo}>
              <h4>Información de Envío</h4>
              <form
                className={styles.shippingForm}
                onSubmit={(e) => {
                  e.preventDefault();
                  updateShipping();
                }}
              >
                <label>
                  Cobrar Envio:
                  <input
                    type="checkbox"
                    checked={envio}
                    onChange={(e) => setEnvio(e.target.checked)}
                  />
                </label>
                <label>
                  Precio:
                  <input
                    type="number"
                    value={precio}
                    onChange={(e) => setPrecio(e.target.value)}
                  />
                </label>
                <label>
                  Cantidad de Kits para envio gratis:
                  <input
                    type="number"
                    value={envioGratis}
                    onChange={(e) => setEnvioGratis(e.target.value)}
                  />
                </label>
                <button type="submit" className={styles.button}>
                  Actualizar Envío
                </button>
              </form>
            </div>
          )}

          {showCreateProductForm && <CreateProductForm />}
          {showProductList && <ProductList />}
          {showCreateSoupKits && <CreateSoupKits />}
          {showKitList && <KitList />}
          {showPedidos && <TraePedidos />}
          <button className={styles.button} onClick={toggleShippingInfo}>
            {showShippingInfo ? "Ocultar Info Envío" : "Info Envío"}
          </button>
        </div>
      )}
    </div>
  );
};

export default Dashboard;
